<template>
  <div
    :class="[
      'vch-filter-list',
      {
        '-disabled': loading,
      },
    ]"
  >
    <template>
      <div class="vch-product-grid">
        <ul class="vch-grid">
          <template v-if="initialProductsLoaded">
            <slot />
          </template>
          <li
            v-show="items.length"
            class="vch-col-6 vch-col-md-4 mb-md"
            style="height: 100%; padding-bottom: 50px; position: relative"
            v-for="item in items"
            :key="item.id"
          >
          <vch-card-article
              v-if="isArticles || (isMixedContent && !item.videoId)"
              :image="isArticles ? item.image : item.articleImage"
              :link="isArticles ? item.link : item.articleLink"
              :description="isArticles ? item.description : item.headerText"
              :title="isArticles ? item.title : item.headerTitle"
              :tagging-data="item.tagging"
            ></vch-card-article>
            <vch-card-video
              v-else-if="isVideos || (isMixedContent && item.videoId)"
              :image="item.image"
              :videoId="item.videoId"
              :description="item.description"
              :title="item.title"
              :transcript="item.transcript"
              :play-video-aria-label="playVideoAriaLabel"
            ></vch-card-video>
            <vch-card-product
              v-else
              :image="item.image"
              :rating="item.rating"
              :range="item.range"
              :claim="item.claim"
              :productName="item.productName"
              :buyOnlineButton="item.buyOnlineButton"
              :tagging="item.tagging"
              :search-page="isProducts && !!keyword.length"
              :link="item.link"
              :buyOnlineEnable="item.buyOnlineEnable"
            ></vch-card-product>
            <meta
              v-if="isVideos"
              itemprop="uploadDate"
              :content="item.createdDate"
            />
          </li>
        </ul>
      </div>
    </template>

    <div class="loadMore" v-if="showLoadMoreBtn">
      <slot name="button" />
    </div>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { setupCardImpressions } from 'Mixins/setupCardImpressions/setupCardImpressions';

export default {
  name: 'vch-filter-list',
  mixins: [setupCardImpressions],
  props: {
    buttonText: {
      type: String,
    },
    api: {
      type: String,
      required: true,
    },
    currentPage: {
      type: String,
      required: true,
    },
    currentPageTemplate: {
      type: String,
      required: true,
    },
    currentPageCategory: {
      type: String,
      required: true,
    },
    pageSize: {
      type: String,
      required: true,
    },
    keyword: {
      type: String,
      required: false,
      default: '',
    },
    totalProductCount: {
      type: String,
      required: true,
    },
    pageType: {
      type: String,
      required: true,
    },
    playVideoAriaLabel: {
      type: String,
      default: 'video',
    },
    productsIds: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      items: [],
      pageNbr: 1,
      label: '',
      impressions: [],
      newItems: null,
      loading: false,
      filters: [],
      busName: 'item-grid',
      isFiltersSelected: false,
      totalFilteredResults: null,
      initialProductsLoaded: true,
    };
  },
  created() {
    eventBus.$on(`${this.busName}:load`, this.loadMoreProducts);
    eventBus.$on(`${this.busName}:filters`, this.onSelectFilter);
  },
  computed: {
    showLoadMoreBtn() {
      if (this.filters?.length) {
        return Number(this.totalFilteredResults) > this.items.length;
      } else {
        return (
          this.items.length + Number(this.pageSize) <
          Number(this.totalProductCount)
        );
      }
    },
    isVideos() {
      return this.pageType === 'video';
    },
    isProducts() {
      return this.pageType === 'product';
    },
    isArticles() {
      return this.pageType === 'article';
    },
    isMixedContent() {
      return this.pageType === 'mixedcontent';
    },
  },
  watch: {
    loading() {
      eventBus.$emit(`${this.busName}:loadingState`, this.loading);
    },
  },
  methods: {
    loadMoreProducts() {
      this.pageNbr = this.pageNbr + 1;
      this.isFiltersSelected = false;
      this.getData();
    },
    getRequestUrl() {
      const queryParams = new URLSearchParams();
      queryParams.set('pagenumber', this.pageNbr);
      queryParams.set('pagesize', this.pageSize);
      queryParams.set('currentpage', this.currentPage);
      queryParams.set('keyword', this.keyword);
      queryParams.set('currentpagetemplate', this.currentPageTemplate);
      queryParams.set('productsids', this.productsIds);
      queryParams.set('currentpagecategory', this.currentPageCategory);
      queryParams.set('pagetype', this.pageType);
      if (!!this.filters && this.filters.length) {
        this.filters.forEach((filter) => {
          queryParams.set(filter.type, filter.label);
        });
      }
      return `${this.api}?${queryParams.toString()}`;
    },
    getData() {
      fetch(this.getRequestUrl())
        .then(async (response) => {
          const data = await response.json();
          // check for error response
          if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
          }
          this.newItems = null;
          if (this.isVideos) {
            this.newItems = data.Data.Videos.length;
            this.items.push(...data.Data.Videos);
          } else if (this.isArticles) {
            this.newItems = data.Data.Articles.length;
            this.items.push(...data.Data.Articles);
          } else if (this.isMixedContent) {
            this.newItems = data.Data.Content.length;
            this.items.push(...data.Data.Content);
          } else {
            if (this.isFiltersSelected) {
              this.items = [];
            }
            this.totalFilteredResults = data.TotalProductCount;
            this.newItems = data.Data.Products.length;
            this.items.push(...data.Data.Products);
            
            eventBus.$emit(
              `${this.busName}:total-filters-result`,
              this.totalFilteredResults
            );

            eventBus.$emit(
              `${this.busName}:update-filters`,
              data.Data.filter || []
            );
          }
          this.$nextTick(() => {
            this.setVideoAttr();
            this.loading = false;
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    setVideoAttr() {
      const videoList = document.querySelectorAll('.vch-grid li');
      if (this.isVideos) {
        videoList.forEach((video) => {
          video.setAttribute('itemprop', 'video');
          video.setAttribute('itemscope', '');
          video.setAttribute('itemtype', 'https://schema.org/VideoObject');
        });
      }
    },

    onSelectFilter(data) {
      this.pageNbr = 1;
      this.loading = true;
      this.isFiltersSelected = true;
      this.initialProductsLoaded = false;
      const obj = {};
      if (data !== null) {
        data.forEach(function (v) {
          obj[v.type] = (obj[v.type] || []).concat(v.value);
        });
        const filters = Object.keys(obj).reduce(function (s, a) {
          s.push({ type: a, label: obj[a].join() });
          return s;
        }, []);
        this.filters = filters;
      } else {
        this.filters = data;
      }
      this.getData();
    },
  },
};
</script>
<style lang="scss" src="./filter-list.scss"></style>
